import { Badge, Button } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useColFilters } from '@data-access';

export const ResultsFiltersButton = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof Button>
>((props, ref) => {
  const { t } = useTranslation();
  const [filters] = useColFilters('results');

  const activeFilters = filters.filter((f) => {
    if (f.value === undefined || f.value === null) return false;
    if (Array.isArray(f.value)) return f.value.length > 0;
    return f.value !== '';
  }).length;

  return (
    <Button
      color="black"
      fw="normal"
      leftSection={<IconSearch size={14} />}
      ref={ref}
      rightSection={
        activeFilters ? (
          <Badge color="orange" variant="light">
            {activeFilters}
          </Badge>
        ) : undefined
      }
      style={{
        borderColor: 'var(--mantine-color-gray-4)',
      }}
      tt="capitalize"
      variant="outline"
      {...props}
    >
      {t('table.filters')}
    </Button>
  );
});

